<template>
  <div class="Save__Container">
    <div class="Save__Align">
      <div class="Save__Window">
        <div>
          <p class="Save__Text_Thanks">
            {{ $t('save-thanks') }}
          </p>
        </div>
        <div>
          <p class="Save__Text_Text">
            {{ $t('save-text') }}
          </p>
        </div>
        <div class="Save__Terms">
          <input
            type="checkbox"
            class="Save__Checkbox Save__Spacing"
            v-model="checked"
          >
          <p class="Save__Spacing Save__Textpa">
            {{ $t('save-accept') }}
          </p>
          <p
            class="Save__Spacing Save__Terms_Button"
            @click="OpenTerms($t('terms-url'))"
          >
            {{ $t('save-terms-conditions') }}
          </p>
        </div>
        <button
          class="Save__ExportButton"
          :style="checked ? 'opacity: 1' : 'opacity: 0.2'"
          :disabled="!checked"
          @click="GeneratePDF()"
          v-show="!loading"
        >
          <p
            class="Save__ExportButton_text"
          >
            {{ $t('save-export-pdf') }}
          </p>
        </button>
        <div
          class="LoaderContainer"
          v-show="loading"
        >
          <div class="sk-circle">
            <div class="sk-circle1 sk-child" />
            <div class="sk-circle2 sk-child" />
            <div class="sk-circle3 sk-child" />
            <div class="sk-circle4 sk-child" />
            <div class="sk-circle5 sk-child" />
            <div class="sk-circle6 sk-child" />
            <div class="sk-circle7 sk-child" />
            <div class="sk-circle8 sk-child" />
            <div class="sk-circle9 sk-child" />
            <div class="sk-circle10 sk-child" />
            <div class="sk-circle11 sk-child" />
            <div class="sk-circle12 sk-child" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pdfMaker from './pdf/pdfService.js'
import { mapGetters } from 'vuex'
import i18n from '@/mixins/i18n'

export default {
  data () {
    return {
      checked: false,
      loading: false
    }
  },
  mixins: [i18n],
  computed: {
    ...mapGetters(['table'])
  },
  methods: {
    OpenTerms (url) {
      let fileName = 'ROCHE_BOBOIS_Corail_Terms_Use.pdf'
      switch (this.$store.getters.selectedLang) {
        case 'fr':
          fileName = 'ROCHE_BOBOIS_Corail_Conditions_Utilisation.pdf'
          break
      }
      window.open('assets/' + fileName, '_blank')
    },
    async GeneratePDF () {
      this.loading = true
      const name = this.trad(this.table.name)
      const wordingDescription = this.$t('pdf-description')
      const wordingVideo = this.$t('pdf-video')
      const wordingUrl = this.$t('pdf-url')
      const wordingPerspective = this.$t('pdf-perspective')
      const wordingProcess = this.$t('pdf-process')
      const wordingCode = this.$t('pdf-code')
      const wordingCodeUrl = this.$t('pdf-code-url')
      const wordingPersonalization = this.$t('pdf-your-personalization')
      const wordingDesign = this.$t('pdf-design')
      const wordingDiningTables = this.$t('pdf-dining-tables')
      const lang = this.$store.getters.selectedLang
      try {
        await pdfMaker.CreatePDF({
          name: name,
          id: this.table.id,
          wordingDescription: wordingDescription,
          wordingVideo: wordingVideo,
          wordingUrl: wordingUrl,
          wordingPerspective: wordingPerspective,
          wordingProcess: wordingProcess,
          wordingCode: wordingCode,
          wordingCodeUrl: wordingCodeUrl,
          wordingPersonalization: wordingPersonalization,
          wordingDesign: wordingDesign,
          wordingDiningTables: wordingDiningTables,
          lang: lang
        })
      } catch (e) {
        console.log(e)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.Save__Container{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  display: flex;
  justify-content: center;
  flex-direction: column;
  box-sizing: border-box;
}

.Save__Align {
  align-self: center;
  display: flex;
  width: 1px;
}

@media screen and (min-width: 1300px) {
  .Save__Window {
    margin-top: 15em;
    margin-left: 9em;
    align-self: flex-start;
    padding-left: 1em;
    height: auto;
    min-width: 500px;
    border-left: 2px lightgray solid
  }
   .Save__Text_Thanks {
   font-size: 1.8em;
   font-weight: 500;
   margin-bottom: 1em;
 }

 .Save__Text_Text {
   font-size: 1.2em;
   font-weight: 100;
   margin-bottom: 1em;
 }

 .Save__Terms{
   display: flex;
   flex-direction: row;
    margin-bottom: 2em;
    font-size: 1em;
 }

 .Save__ExportButton {
   background: black;
   padding: 1em 2.5em 1em 2.5em;
   border-radius: 5px;
    pointer-events: auto;
 }
}

@media screen and (max-width: 1300px) {
  .Save__Window {
    margin-top: 12em;
    margin-left: 5em;
    align-self: flex-start;
    padding-left: 1em;
    height: auto;
    min-width: 500px;
    border-left: 2px lightgray solid
  }
   .Save__Text_Thanks {
   font-size: 1.4em;
   font-weight: 300;
   margin-bottom: 1em;
 }

 .Save__Text_Text {
   font-size: 0.8em;
   font-weight: 100;
   margin-bottom: 1em;
 }

 .Save__Terms{
   display: flex;
   flex-direction: row;
    margin-bottom: 1em;
    font-size: 1em;
    font-weight: 100;
 }

 .Save__ExportButton {
   background: black;
   padding: 0.8em 2em 0.8em 2em;
   border-radius: 5px;
    pointer-events: auto;
 }
}

input {
  width: 20px;
  height: 20px;
}

 .Save__Checkbox {
  pointer-events: auto;
 }

 .Save__Textpa {
   margin-left: 0.5em;
 }

 .Save__Spacing{
   margin-right: 0.5em;
   align-self: center;
 }

 .Save__Terms_Button {
   border-bottom: 1px solid black;
   pointer-events: auto;
 }

 .Save__ExportButton_text{
   color: white;
   font-size: 1em;
   font-weight: 600;
 }

.LoaderContainer{
  margin: auto;
  display: flex;
  justify-content: flex-start;
  pointer-events: none;
}

.sk-circle {
  margin-left: 1em;
  width: 40px;
  height: 40px;
  position: relative;
}
.sk-circle .sk-child {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}
.sk-circle .sk-child:before {
  content: '';
  display: block;
  margin: 0 auto;
  width: 15%;
  height: 15%;
  background-color: black;
  opacity: 0.5;
  border-radius: 100%;
  -webkit-animation: sk-circleBounceDelay 1.2s infinite ease-in-out both;
          animation: sk-circleBounceDelay 1.2s infinite ease-in-out both;
}
.sk-circle .sk-circle2 {
  -webkit-transform: rotate(30deg);
      -ms-transform: rotate(30deg);
          transform: rotate(30deg); }
.sk-circle .sk-circle3 {
  -webkit-transform: rotate(60deg);
      -ms-transform: rotate(60deg);
          transform: rotate(60deg); }
.sk-circle .sk-circle4 {
  -webkit-transform: rotate(90deg);
      -ms-transform: rotate(90deg);
          transform: rotate(90deg); }
.sk-circle .sk-circle5 {
  -webkit-transform: rotate(120deg);
      -ms-transform: rotate(120deg);
          transform: rotate(120deg); }
.sk-circle .sk-circle6 {
  -webkit-transform: rotate(150deg);
      -ms-transform: rotate(150deg);
          transform: rotate(150deg); }
.sk-circle .sk-circle7 {
  -webkit-transform: rotate(180deg);
      -ms-transform: rotate(180deg);
          transform: rotate(180deg); }
.sk-circle .sk-circle8 {
  -webkit-transform: rotate(210deg);
      -ms-transform: rotate(210deg);
          transform: rotate(210deg); }
.sk-circle .sk-circle9 {
  -webkit-transform: rotate(240deg);
      -ms-transform: rotate(240deg);
          transform: rotate(240deg); }
.sk-circle .sk-circle10 {
  -webkit-transform: rotate(270deg);
      -ms-transform: rotate(270deg);
          transform: rotate(270deg); }
.sk-circle .sk-circle11 {
  -webkit-transform: rotate(300deg);
      -ms-transform: rotate(300deg);
          transform: rotate(300deg); }
.sk-circle .sk-circle12 {
  -webkit-transform: rotate(330deg);
      -ms-transform: rotate(330deg);
          transform: rotate(330deg); }
.sk-circle .sk-circle2:before {
  -webkit-animation-delay: -1.1s;
          animation-delay: -1.1s; }
.sk-circle .sk-circle3:before {
  -webkit-animation-delay: -1s;
          animation-delay: -1s; }
.sk-circle .sk-circle4:before {
  -webkit-animation-delay: -0.9s;
          animation-delay: -0.9s; }
.sk-circle .sk-circle5:before {
  -webkit-animation-delay: -0.8s;
          animation-delay: -0.8s; }
.sk-circle .sk-circle6:before {
  -webkit-animation-delay: -0.7s;
          animation-delay: -0.7s; }
.sk-circle .sk-circle7:before {
  -webkit-animation-delay: -0.6s;
          animation-delay: -0.6s; }
.sk-circle .sk-circle8:before {
  -webkit-animation-delay: -0.5s;
          animation-delay: -0.5s; }
.sk-circle .sk-circle9:before {
  -webkit-animation-delay: -0.4s;
          animation-delay: -0.4s; }
.sk-circle .sk-circle10:before {
  -webkit-animation-delay: -0.3s;
          animation-delay: -0.3s; }
.sk-circle .sk-circle11:before {
  -webkit-animation-delay: -0.2s;
          animation-delay: -0.2s; }
.sk-circle .sk-circle12:before {
  -webkit-animation-delay: -0.1s;
          animation-delay: -0.1s; }

@-webkit-keyframes sk-circleBounceDelay {
  0%, 80%, 100% {
    -webkit-transform: scale(0);
            transform: scale(0);
  } 40% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
}

@keyframes sk-circleBounceDelay {
  0%, 80%, 100% {
    -webkit-transform: scale(0);
            transform: scale(0);
  } 40% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
}
</style>
